import linkedInActionConstants from '../constants/linkedInActionConstants';

const initialState = {
  importStartTime: null,
  loading: false,
  showLinkedInImportTimer: false,
};

const linkedInImportReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case linkedInActionConstants.SET_LINKEDIN_IMPORT_START_TIME:
      return {
        ...state,
        importStartTime: action.payload,
        showLinkedInImportTimer: true,
      };
    case linkedInActionConstants.UNSET_LINKEDIN_IMPORT_START_TIME:
      return {
        ...state,
        importStartTime: null,
      };
    case linkedInActionConstants.IMPORT_LINKEDIN_CONTACTS_SUCCESS:
      return {
        ...state,
        showLinkedInImportTimer: false,
      };
    case linkedInActionConstants.SET_LOADER_ON:
      return {
        ...state,
        loading: true,
      };
    case linkedInActionConstants.SET_LOADER_OFF:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default linkedInImportReducer;
